import { formatAmount } from "../../include/money";
import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { callPostApi } from "../../function/ApiCallFunction";
import { REACT_ENV } from "../../include/config";
import { consoleColors } from "../admin/consoleTheme";
import { cashiLogo } from "../../include/cashiBrand";
import { buildOrderTickets, saveTicketFile, shareTicketFile } from "../../include/ticketImage";

export default function DrawTicketSuccess() {
  const [params] = useSearchParams();
  const txnid = params.get("txnid") || "";
  const [order, setOrder] = useState(null);
  const [cards, setCards] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    let mounted = true;
    const mod = String(REACT_ENV) === "LIVE" ? "TICKET_ORDER" : "TICKET_COMPLETE";
    callPostApi("draw-ticket", { mod, data_arr: { txnid, env: REACT_ENV } }).then((result) => {
      if (!mounted) return;
      if (result.status === "200" && result.data?.order?.status === "success") setOrder(result.data.order);
      else setError(result.status_message || result.data?.error || "Payment is not complete");
    });
    return () => { mounted = false; };
  }, [txnid]);

  useEffect(() => {
    if (!order) return undefined;
    let mounted = true;
    buildOrderTickets(order, order.title, order.image).then((next) => { if (mounted) setCards(next); }).catch(() => toast.error("Could not prepare the ticket image"));
    return () => { mounted = false; };
  }, [order]);

  const shareText = (card) => `Lucky Draw Ticket\n${order?.title || ""}\n${order?.customer_name || ""}\n${card.code}`;

  return (
    <Box sx={{ minHeight: "100vh", position: "relative", overflow: "auto", display: "flex", alignItems: "flex-start", justifyContent: "center", px: 2, py: 4, background: consoleColors.sidebar }}>
      <Confetti />
      <Box sx={{ position: "relative", zIndex: 1, width: "100%", maxWidth: 480, textAlign: "center", color: "#fff" }}>
        <Box component="img" src={cashiLogo} alt="Cashi" sx={{ height: 36, width: "auto", mb: 2 }} />
        {error ? (
          <Typography sx={{ fontSize: 28, fontWeight: 850 }}>{error}</Typography>
        ) : !order ? (
          <Typography sx={{ fontSize: 28, fontWeight: 850 }}>Confirming your payment</Typography>
        ) : (
          <Box sx={{ animation: "cashi-pop 0.55s ease" }}>
            <Box sx={{ width: 92, height: 92, mx: "auto", borderRadius: "50%", background: "rgba(255,255,255,0.18)", display: "grid", placeItems: "center", fontSize: 48, border: "3px solid rgba(255,255,255,0.75)" }}>✓</Box>
            <Typography sx={{ fontSize: { xs: 32, sm: 42 }, fontWeight: 900, lineHeight: 1.1, mt: 2 }}>Payment successful</Typography>
            <Typography sx={{ fontSize: 18, mt: 1.2 }}>{order.customer_name} · {order.qty} Lucky Draw Ticket{order.qty === 1 ? "" : "s"}</Typography>
            <Typography sx={{ fontSize: 16, mt: 0.6, opacity: 0.95 }}>{order.qty} × ₹{formatAmount(order.unit_price)} = ₹{formatAmount(order.amount)}</Typography>
            <Box sx={{ display: "grid", gap: 2, mt: 2.5, justifyItems: "center" }}>
              {cards.map((card) => (
                <Box key={card.code} sx={{ width: "100%", maxWidth: 280 }}>
                  <Box component="img" src={card.dataUrl} alt="Lucky Draw Ticket" sx={{ width: "100%", borderRadius: 3, boxShadow: "0 16px 40px rgba(0,0,0,0.28)" }} />
                  <Box sx={{ display: "flex", gap: 1, mt: 1.2 }}>
                    <button type="button" onClick={() => saveTicketFile(card)} style={{ ...actionBtn, background: "#fff", color: "#111" }}>Save</button>
                    <button type="button" onClick={() => shareTicketFile(card, shareText(card)).catch((error) => { if (error?.name !== "AbortError") toast.error("Could not share the ticket"); })} style={{ ...actionBtn, background: "#25D366", color: "#fff" }}>WhatsApp</button>
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        )}
      </Box>
      <style>{`
        @keyframes cashi-fall { 0% { transform: translateY(-24px) rotate(0deg); opacity: 1; } 100% { transform: translateY(110vh) rotate(280deg); opacity: 0.15; } }
        @keyframes cashi-pop { 0% { transform: scale(0.72); opacity: 0; } 70% { transform: scale(1.05); opacity: 1; } 100% { transform: scale(1); } }
      `}</style>
    </Box>
  );
}

const actionBtn = {
  flex: 1,
  minHeight: 44,
  borderRadius: 12,
  border: 0,
  fontWeight: 800,
  fontSize: 15,
  cursor: "pointer",
};

function Confetti() {
  const colors = ["#21a7ec", "#7dd3fc", "#ffffff", "#1788c9", "#bae6fd"];
  return (
    <Box sx={{ position: "absolute", inset: 0, pointerEvents: "none" }}>
      {colors.concat(colors, colors, colors).map((color, index) => (
        <Box key={index} sx={{ position: "absolute", top: -20, left: `${(index * 13) % 100}%`, width: index % 3 === 0 ? 14 : 10, height: index % 2 === 0 ? 18 : 10, borderRadius: index % 2 ? "50%" : "2px", background: color, animation: `cashi-fall ${2.4 + (index % 5) * 0.35}s linear ${(index % 8) * 0.12}s infinite` }} />
      ))}
    </Box>
  );
}
